import { connect } from 'react-redux';
import { scrollToTop } from 'zoomforth_codesbane_viewer/action_creators/viewer.js';
import ScrollToTop from './scroll_to_top.jsx';

const mapStateToProps = (state, props) => ({});
const mapDispatchToProps = (dispatch, props) => ({
  onScrollToTop: ()=> dispatch(scrollToTop())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ScrollToTop);


